"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_1 = __importDefault(require("@emotion/styled"));
var styled_system_1 = require("styled-system");
var box_1 = require("./box");
exports.Grid = styled_1.default(box_1.Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["  \n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  display: grid;\n"], ["  \n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  display: grid;\n"])), styled_system_1.gridGap, styled_system_1.gridRowGap, styled_system_1.gridColumnGap, styled_system_1.gridColumn, styled_system_1.gridRow, styled_system_1.gridAutoFlow, styled_system_1.gridAutoRows, styled_system_1.gridAutoColumns, styled_system_1.gridTemplateRows, styled_system_1.gridTemplateColumns, styled_system_1.gridTemplateAreas);
exports.Grid.displayName = "Grid";
var templateObject_1;
